<div *ngIf="isDataLoaded" [ngStyle]="{'display': isDataLoaded ? 'block' : 'none'}">
<router-outlet></router-outlet>
<ngx-ui-loader></ngx-ui-loader>
</div>